import React from 'react';
import { Link } from 'react-router';
import cn from 'classnames';
import { Icon } from 'legacy-packages/ft-cb';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import './ShareableResourcePopover.scss';

const ShareableResourcePopover = ({
  label,
  displayName,
  metadata,
  url,
  onClick,
  extraLinkProps,
  children,
}) => {
  const screenWidth = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  );
  const screenHeight = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0,
  );
  const popupWidth = 600;
  const popupHeight = 600;
  const popupX = screenWidth / 2 - popupWidth / 2;
  const popupY = screenHeight / 2 - popupHeight / 2;

  return (
    <div className="shareable-popover">
      <PopOver
        className="popoverIndicator"
        size="medium"
        accessibility={{
          'aria-label': `${displayName} info`,
          'aria-describedby': `${displayName}-info-tooltip`,
        }}
        trigger={children}
      >
        <div className="shareable-resources-popover">
          <div className={cn('option', 'bordered-bottom')}>
            <Icon width={20} height={18} name="arrow-east" />
            <Link
              onClick={onClick}
              title={displayName}
              target="_blank"
              params={metadata}
              {...extraLinkProps}
            >
              <span className="label">{label}</span>
            </Link>
          </div>
          <div className="option">
            <Icon width={20} height={18} name="google-classroom" />
            <a
              href={`javascript:PreAPShareToGoogleClassroom=window.open('https://classroom.google.com/share?url=${url}','PreAPShareToGoogleClassroom','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,width=${popupWidth},height=${popupHeight},top=${popupY},left=${popupX}');`}
              target="_self"
            >
              <span className="label">Share to Google Classroom</span>
            </a>
          </div>
        </div>
      </PopOver>
    </div>
  );
};

export default ShareableResourcePopover;
